<template>
    <div v-separator-link="200">
        <div class="gcmcn-form-title">Add a user</div>
        <div class="gcmcn-card">
            <el-form :model="form" :rules="rules" ref="form">
                <el-form-item class="gcmcn-form-input" prop="email">
                    <div class="gcmcn-form-label">Email</div>
                    <el-autocomplete
                        v-model="form.email"
                        size="mini"
                        value-key="verbose_name"
                        popper-class="gcmcn-popper"
                        :fetch-suggestions="querySearch"
                    ></el-autocomplete>
                    <div class="form-info">
                        Create accounts for users. Select an existing user account or type a new email address.
                    </div>
                </el-form-item>
                <div class="text-right">
                    <el-button
                        type="text"
                        @click="leave"
                    >Cancel</el-button>
                    <el-button
                        :loading="loading"
                        type="primary"
                        class="gcmcn-primary-btn small"
                        @click="validateForm"
                    >Save
                    </el-button>
                </div>
            </el-form>
        </div>
    </div>
</template>
<script>
export default {

    components: {
    },

    props: {
        users: {
            type: Array,
            required: true
        },
        entityUid: {
            type: String,
            required: true,
        },
        role:{
            type: String,
            required: true,
        }
    },

    data (){
        return {
            form: {
                email: '',
            },
            loading: false,
        };
    },

    computed: {
        rules () {
            return {
                email: [{ required: true, message: 'An email is required' }],
            };
        },

    },
    methods: {
        querySearch (queryString, cb){
            let results = this.users.filter((u) => {
                return u.level === 'manager' && u.verbose_name.toLowerCase().includes(queryString.toLowerCase());
            });
            cb(results);
        },
        validateForm (){
            this.$refs.form.validate((valid) => {
                if(valid){
                    this.loading = true;
                    this.$store.dispatch('createItem', {
                        item:{
                            action: 'ADD',
                            email: this.form.email,
                            level: this.role,
                            status: 'PENDING',
                        },
                        scopes: {'X-Entity-Uid': this.entityUid},
                        model: 'userManagementRequests',
                        url: this.$store.state.api.meta.listModels.userManagementRequests.url,
                    })
                    .then(async (res) => {
                        this.$store.dispatch('fundation/watchRequestStatus',{
                            url: res.url
                        }).then(() => {
                            this.$emit('on-user-created');
                            this.$notify.success({
                                title: 'Success',
                                message: ` User ${this.form.email} successfully added to entity.`
                            });
                            this.loading = false;
                        }).catch(error => {
                            this.$message.error(error.data.verbose_status);
                            this.loading = false;
                        });
                    }).catch((e) => {
                        console.error(e);
                        this.$message.error(`Error while adding user ${this.form.email}`);
                        this.loading = false;
                    });
                }
            });
        },
        leave (){
            this.$emit('leave-form-view');
        },
    },
};
</script>

<style lang="scss">
.crop-rules{
    text-transform: initial;
    color: #bbb;
}
.inputs-container{
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;

    .flex-basis-5{
        flex-basis: calc( 50% - 10px);
    }
    .flex-basis-10{
        flex-basis: 100%;
    }
}

</style>



// WEBPACK FOOTER //
// src/components/page/Entities/user-form.vue